package com.rainbowclubs.rainbow.data.requests

import com.rainbowclubs.rainbow.data.models.AttendeeStatus
import kotlinx.serialization.Serializable

@Serializable
data class UpdateEventAttendeeRequest(
    val eventId: String,
    val status: AttendeeStatus,
)